import { useState } from 'react';
import I18n from 'I18n';
import styled from 'styled-components';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import { EERIE } from 'HubStyleTokens/colors';
// @ts-expect-error migrate upstream files
import { getName } from 'dashboard-lib/public/report/report-schema';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { isStaticWidget
// @ts-expect-error migrate upstream files
} from 'dashboard-lib/public/report/report-logic';
import UIIcon from 'UIComponents/icon/UIIcon';
import { isAcceptanceTestPortal } from '../../../lib/isAcceptanceTestPortal';
import { useWidgetContext } from '../WidgetContext';
import { AsyncReportDescriptionTooltip as ReportDescriptionTooltip } from './AsyncReportDescription';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { VerticalMenuIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FloatingActionsContainer = styled.div.withConfig({
  displayName: "DashboardCardHeader__FloatingActionsContainer",
  componentId: "w5sskw-0"
})(["position:absolute;z-index:1;right:10px;"]);
const WidgetActionsButton = buttonProps => /*#__PURE__*/_jsx(IconButton, Object.assign({
  use: "link",
  "aria-label": I18n.text('dashboardReport.action.actions'),
  marginInlineStart: "200"
}, buttonProps, {
  children: /*#__PURE__*/_jsx(VerticalMenuIcon, {
    "data-draggable": "false"
  })
}));
export const DashboardCardHeaderTitle = ({
  report
}) => {
  const reportName = getName(report);
  return /*#__PURE__*/_jsx(Text, {
    as: "h5",
    children: /*#__PURE__*/_jsxs(TruncateString, {
      useFlex: true,
      fixedChildren: !isStaticWidget(report) && /*#__PURE__*/_jsx(ReportDescriptionTooltip, {
        report: report,
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "info",
          color: EERIE
        })
      }),
      children: [reportName, " \xA0"]
    })
  });
};
export const DashboardCardHeader = ({
  actionList,
  additionalAction,
  itemLeft = null,
  isPresentation = false
}) => {
  const {
    report
  } = useWidgetContext();
  const reportName = getName(report);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const actionsDropdown = /*#__PURE__*/_jsx(UIDropdown, {
    "data-draggable": "false",
    buttonUse: "link",
    Button: WidgetActionsButton,
    "data-test-id": "report-actions-button",
    onOpenChange: () => setIsDropdownOpen(!isDropdownOpen),
    open: isDropdownOpen,
    placement: "bottom left",
    children: actionList
  });
  const shouldRenderActionsDropdownOnly = isStaticWidget(report) && !reportName;
  return shouldRenderActionsDropdownOnly ? /*#__PURE__*/_jsx(FloatingActionsContainer, {
    "data-dropdown-open": isDropdownOpen || isAcceptanceTestPortal(),
    "data-group-id": "widget-actions-container",
    children: !isPresentation && actionsDropdown
  }) : /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsxs(Flex, {
      children: [itemLeft, /*#__PURE__*/_jsx(DashboardCardHeaderTitle, {
        report: report
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      "data-group-id": "widget-actions-container",
      "data-dropdown-open": isDropdownOpen || isAcceptanceTestPortal(),
      children: [additionalAction, actionsDropdown]
    })]
  });
};